import styled from "@emotion/styled";
import { ModalContent } from "shared/Modal/styled";
import { ModalTitle, PreviewVideo } from "components/RecipeSteps/Preview/styled";
import { ButtonWrap } from "shared/Button/styled";

export const ModalContainer = styled.div`
  .btnGroup {
    display: flex;
    align-items: center;
    button {
      min-width: 90px;
    }
    svg {
      margin-left: 30px;
    }
  }
  .colContent {
    display: flex;
    margin-top: 21px;
    justify-content: space-between;

    @media (max-width: 769px) {
      flex-direction: column;
    }
  }

  .modalBtn {
    margin-left: 30px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    @media (max-width: 769px) {
      margin-left: 0;

      button {
        padding-left: 0;
      }
    }
  }

  ${PreviewVideo} {
    margin-bottom: 39px;
    @media (max-width: 769px) {
      height: 328px;
      margin-bottom: 30px;
    }
  }

  ${ModalContent} {
    padding: 28px 40px 28px 40px;
    @media (max-width: 769px) {
      padding: 30px 16px 50px 16px;
    }
  }
  ${ModalTitle} {
    margin: 0px;
    border: none;
    padding-bottom: 20px;
    display: flex;
    align-items: center;
  }
`;

export const BtnWrap = styled.div`
  margin-bottom: 30px;
  ${ButtonWrap} {
    width: 100%;
  }
`;
